import { RecipeBuilderActionMode, RecipeDialogType, RecipeDisplayMode, } from "./recipe.types";
const RecipeState = {
    inUse: false,
    isLocked: false,
    mode: RecipeDisplayMode.RECIPE_BUILDER,
    recipeBuilderActionMode: RecipeBuilderActionMode.PAN,
    plusIconPlacement: { previousStepId: undefined },
    stepsList: null,
    selectedStepIds: [],
    alternativeStepNames: [],
    alternativeStepActiveFlows: {},
    gasNames: [],
    liquidNames: [],
    parameterNames: [],
    customVariableDefaultName: null,
    currentCustomVariableFormulaStatus: null,
    customVariableTransformations: [],
    state: {
        gases: [],
        liquids: [],
        parameters: [],
        steps: [],
        customVariables: [],
    },
    dialogs: {
        [RecipeDialogType.STEP]: {
            isOpen: false,
        },
        [RecipeDialogType.CONDITIONAL_FLOW]: {
            isOpen: false,
        },
        [RecipeDialogType.GAS]: {
            isOpen: false,
        },
        [RecipeDialogType.LIQUID]: {
            isOpen: false,
        },
        [RecipeDialogType.CUSTOM_VARIABLE]: {
            isOpen: false,
        },
        [RecipeDialogType.ALTERNATIVE_STEP]: {
            isOpen: false,
        },
    },
    editableParameter: undefined,
};
export default RecipeState;
